export default __webpack_public_path__ + "static/media/logo-adman.2aaaf369.png";